import { useMemo, useCallback } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation } from "@l2r-front/l2r-networks"

import { APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADWORKS } from "../../../../common/constants/modules"
import { SELECTED_ROADWORK_URL_PARAM, SELECTED_TECHNIQUE_URL_PARAM } from "../../constants/techniques"
import { RoadworkSectionLayer } from "../../containers/RoadworkSectionLayer"
import { RoadworksLayer } from "../../containers/RoadworksLayer"
import { RoadworkTechniquesLayer } from "../../containers/RoadworkTechniquesLayer"
import { useRoadworksDispatchContext } from "../../contexts/RoadworksContext"

import { RoadworkValidator } from "../RoadworkValidator/RoadworkValidator"

export function RoadworksMapLayersRouter() {

    const matchRoad = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADWORKS}/:road/*`)
    const isSegmentView = !!matchRoad
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSelectedSegment, setSelectedTechnique, setSelectedRoadwork } = useRoadworksDispatchContext()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedSegment(feature)
            setSelectedTechnique(null)
            setSelectedRoadwork(null)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, paramsToRemove: [SELECTED_TECHNIQUE_URL_PARAM, SELECTED_ROADWORK_URL_PARAM], navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked,
        setSelectedSegment,
        setSelectedTechnique,
        setSelectedRoadwork,
        navigateToLinearLocation,
        isSegmentView,
        road])

    const roadworksMapRoutes = useMemo(() => ([
        {
            path: "/",
            element: <>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <RoadworkTechniquesLayer />
            </>,
        },
        {
            path: "/:road/*",
            element: <>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <RoadworksLayer />
                <ImageCollectionLayer road={road} />
                <ImageSelectedLayer />
            </>,
        },
        {
            path: "/:road/:roadworkUuid",
            element: <RoadworkValidator>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <RoadworkSectionLayer />
                <ImageCollectionLayer road={road} />
                <ImageSelectedLayer />
            </RoadworkValidator>,
        },
    ]), [processNavigation, road])

    return useRoutes(roadworksMapRoutes)
}